import styled from 'styled-components/macro';
import { darken } from 'polished';
import { Button } from 'react-bootstrap';

export const ThemedButton = styled(Button)<
  Button & { background: string; color: string }
>`
  background-color: ${({ background }) => background};
  border-color: ${({ background }) => background};
  color: ${({ color }) => color};
  min-width: 115px;

  &:hover {
    background-color: ${({ background }) => darken(0.1, background)};
    border-color: ${({ background }) => darken(0.1, background)};
    color: ${({ color }) => color};
  }
`;
